import { createUseStyles } from 'react-jss';

export default createUseStyles(
  {
    '@keyframes modalFade': {
      from: { opacity: 0.5 },
      to: { opacity: 1 },
    },
    '@keyframes modalShift': {
      '0%': {
        top: -500,
      },
      '100%': {
        top: '50%',
      },
    },
    root: {
      position: 'fixed',
      left: 0,
      top: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      animation: '$modalFade 0.5s ease-in-out',
      zIndex: 10000,
      width: '100vw',
    },
    rootReverse: {
      position: 'fixed',
      left: 0,
      top: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.25)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      animation: '$modalFade 0.25s ease-in-out',
      animationDirection: 'reverse',
      opacity: 0,
      transition: 'all 0.25s ease-in-out',
      zIndex: 10000,
    },
    exitIcon: {
      color: 'black',
      cursor: 'pointer',
      height: 15,
      width: 15,
    },
    headerContent: {
      minWidth: '92%',
      marginLeft: 25,
      textAlign: 'left',
    },
    headerText: {
      display: 'flex',
      justifyContent: 'space-between',
      '-webkit-justify-content': 'space-between',
    },
    subHeader: {
      marginTop: 4,
      display: 'flex',
    },
    modalContent: {
      position: 'fixed',
      top: '50%',
      left: '50%',
      /* bring your own prefixes */
      transform: 'translate(-50%, -50%)',
      border: '1px solid #fff',
      backgroundColor: '#fff',
      borderRadius: '15px',
      padding: 15,
      animation: '$modalShift 0.55s ease-in-out',
    },
    modalContentReverse: {
      position: 'fixed',
      top: -500,
      left: '50%',
      /* bring your own prefixes */
      transform: 'translate(-50%, -50%)',
      border: '1px solid #fff',
      backgroundColor: '#fff',
      borderRadius: '15px',
      padding: 15,
      animation: '$modalShift 0.25s ease-in-out',
      animationDirection: 'reverse',
      transition: 'all 0.25s ease-in-out',
    },
    modalTitle: {
      marginTop: 20,
      width: '100%',
    },
    modalImage: {
      width: '90vw',
      maxWidth: 750,
      marginTop: 24,
      ['@media (max-width: 768px)']: {
        maxWidth: 450,
      },
    },
  },
  {
    name: 'Auth0Modal',
  },
);
